"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const HeaderBar_1 = tslib_1.__importDefault(require("../HeaderBar"));
const LayoutContext_1 = tslib_1.__importDefault(require("./LayoutContext"));
class AppContext extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.componentWillUnmount = () => {
            this.context.unsetBreadcrumbs();
            this.context.unsetTitle();
            this.context.unsetBackAction();
        };
    }
    componentDidMount() {
        this.init();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.title !== this.props.title ||
            prevProps.backUrl !== this.props.backUrl ||
            JSON.stringify(prevProps.breadcrumbs) !==
                JSON.stringify(this.props.breadcrumbs)) {
            this.init();
        }
    }
    init() {
        const { breadcrumbs, title, backUrl } = this.props;
        if (breadcrumbs) {
            this.context.setBreadcrumbs(breadcrumbs.map(breadcrumb => {
                const { url, name } = breadcrumb;
                if (url) {
                    return React.createElement(react_router_dom_1.Link, { to: url }, name);
                }
                else {
                    return name;
                }
            }));
        }
        if (title) {
            this.context.setTitle(title);
        }
        if (backUrl) {
            this.context.setBackAction(React.createElement(HeaderBar_1.default.Action, { icon: "back", as: react_router_dom_1.Link, to: backUrl }));
        }
    }
    render() {
        return null;
    }
}
AppContext.contextType = LayoutContext_1.default;
exports.default = AppContext;
